/* Copyright (c) 2020-present CloudIO Inc */

import React from 'react';
import { useEffect, useState } from 'react';

interface Props {
  appUid: string;
  pageId: string;
  paramString: string;
}

export default function PageRendered(props: Props) {
  const { appUid, pageId } = props;
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    setPageLoaded(true);
  }, [appUid, pageId]);

  if (!pageLoaded) {
    return null;
  }

  return (
    <div
      data-testid={`io-page-rendered-${appUid}-${pageId}`}
      style={{ visibility: 'hidden', width: 0, height: 0 }}
    />
  );
}
